<template>
    <select
        :class="classes"
        :placeholder="placeholder"
        :value="value"
        @change="valueChanged"
    >
        <option v-if="placeholder" disabled :value="undefined">{{ placeholder }}</option>
        <slot></slot>
    </select>
</template>

<script>
  export default {
    components: {},
    props: {
      classes: {},
      placeholder: {},
      value: {
        default: undefined
      }
    },
    computed: {},
    methods: {
      valueChanged (event) {
        this.$emit('input', event.target.value)
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
    select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// client/components/ui/singleselect.vue